import {
  Component,
  OnInit,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "app/shared/services/api.service";
import moment from "moment";
import {
  ApexAxisChartSeries,
  ApexNonAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexStroke,
  ApexGrid,
  ApexLegend,
  ApexTooltip,
  ApexPlotOptions,
  ApexFill,
  ApexMarkers,
  ApexTheme,
  ApexResponsive,
} from "ng-apexcharts";
import { ChartEvent, ChartType } from "ng-chartist";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

var $primary = "#975AFF",
  $success = "#40C057",
  $info = "#2F8BE6",
  $warning = "#F77E17",
  $danger = "#F55252",
  $label_color_light = "#E6EAEE";
var themeColors = [$warning, $danger, $primary, $info, $success];
var channelthemeColors = [$info, $warning];
export type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  colors: string[];
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  title: ApexTitleSubtitle;
  dataLabels: ApexDataLabels;
  stroke: ApexStroke;
  grid: ApexGrid;
  legend?: ApexLegend;
  tooltip?: ApexTooltip;
  plotOptions?: ApexPlotOptions;
  labels?: string[];
  fill: ApexFill;
  markers?: ApexMarkers;
  theme: ApexTheme;
  responsive: ApexResponsive[];
};
export interface Chart {
  type: ChartType;
  data: Chartist.IChartistData;
  options?: any;
  responsiveOptions?: any;
  events?: ChartEvent;
}
@Component({
  selector: "app-all-leads-reports",
  templateUrl: "./all-leads-reports.component.html",
  styleUrls: ["./all-leads-reports.component.scss"],
})
export class AllLeadsReportsComponent implements OnInit {
  currentUrl: any;
  resports_count = [];
  resports_Data: any = [];

  reportList_data: any = [];
  monthData: any = [];
  monthCount: any = [];
  cardColors = [
    { cardColor: "bg-success", textColor: "success" },
    { cardColor: "bg-info", textColor: "info" },
    { cardColor: "bg-primary", textColor: "primary" },
    { cardColor: "bg-danger", textColor: "danger" },
    { cardColor: "bg-warning", textColor: "warning" },
  ];
  columnChartOptions: Partial<ChartOptions>;
  channelChartOptions: Partial<ChartOptions>;
  leadsReports: any;
  leadStagereports: any;
  trainingLead = "63e39db72052e0098e18e00e";
  softwarelead = "63e39dd62052e0098e18e015";
  toDay = new Date();
  leadToDate = this.toDay.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  leadFromDate = new Date(
    this.toDay.getFullYear(),
    this.toDay.getMonth() - 1,
    this.toDay.getDate()
  ).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  sourceList: any;
  source_tagcat_id = "63ef44bb5fb91668b7f123ba";
  selected_source = "63ef45065fb91668b7f123c3";
  technology_List: any;
  technology_catId = "6319d5025ab9e462a96cfbba";
  selectedTechnology = "All";
  channelFromDate: any;
  channelToDate: any;
  selectedTechnologyId: any;

  guideline_data: any;
  filterList=[
    {name:'All'},
    {name:'Today'},
    {name:'Last 3 Days'},
    {name:'This Week'},
    {name:'This Month'},
  ]
  selected_filter = null
  constructor(
    public apiService: ApiService,
    private activerouter: ActivatedRoute,
    private modalService: NgbModal
  ) {
    this.leadFromDate = moment(this.leadFromDate, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    this.leadToDate = moment(this.leadToDate, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    this.channelToDate = this.leadToDate;
    this.channelFromDate = this.leadFromDate;
    this.currentUrl = this.activerouter.snapshot.routeConfig.path;
    if (this.currentUrl == "training-leads-reports") {
      this.getleadStageReports("63e39db72052e0098e18e00e",'','');
      let setting_data = JSON.parse(localStorage.getItem("setting-record"));
      let key_data = setting_data.filter(
        (item) => item.key == "Training Lead Reports"
      );
      this.guideline_data = key_data[0]?._id;
    }
    if (this.currentUrl == "outsource-leads-reports") {
      this.getleadStageReports("63e39dd62052e0098e18e015",'','');
      let setting_data = JSON.parse(localStorage.getItem("setting-record"));
      let key_data = setting_data.filter(
        (item) => item.key == "OutSourcing Lead Reports"
      );
      this.guideline_data = key_data[0]?._id;
    }
  }
  ngOnInit(): void {
    this.getReports();
    this.getSource();
    this.getTechnologyList();
    this.getChannelReport("All", "All",this.channelFromDate,this.channelToDate);
  }
  onResized(event: any) {
    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }
  fireRefreshEventOnWindow = function () {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  }
  getleadStageReports(id,fromDate,toDate) {
    this.apiService.getleadStageReports(id,fromDate,toDate).subscribe(
      (res: any) => {
        if (res && res.data) {
          let data = res.data.filter(item => item._id !== null);
          this.leadStagereports = data
            .sort((a, b) => {
              if (a.name && b.name) {
                return a.name.localeCompare(b.name);
              }
              return 0;
            })
            .reverse();

          for (let i = 0; i < this.leadStagereports.length; i++) {
            let percent = 0;
            const currentReport = this.leadStagereports[i];
            const findReport = (name) =>
            this.leadStagereports.find((item) => item.name === name);
            const getTotal = (name) => {
              const report = findReport(name);
              return report ? report.total : 0;
            };

            if (currentReport.name === "nurture") {
              currentReport.bg = this.cardColors[2].cardColor
              currentReport.textColor = this.cardColors[2].textColor
              const nurtureTotal = getTotal("nurture");
              percent =
                (currentReport.total / (nurtureTotal + currentReport.total)) *
                100;
            } else if (currentReport.name === "won") {
              currentReport.bg = this.cardColors[0].cardColor
              currentReport.textColor = this.cardColors[0].textColor
              const wonTotal = getTotal("won");
              percent =
                (currentReport.total / (wonTotal + currentReport.total)) * 100;
            } else if (currentReport.name === "lost") {
              currentReport.bg = this.cardColors[3].cardColor
              currentReport.textColor = this.cardColors[3].textColor
              const lostTotal = getTotal("lost");
              percent =
                (currentReport.total / (lostTotal + currentReport.total)) * 100;
            } else if (currentReport.name === "hot") {
              currentReport.bg = this.cardColors[4].cardColor
              currentReport.textColor = this.cardColors[4].textColor
              const hotTotal = getTotal("hot");
              percent =
                (currentReport.total / (hotTotal + currentReport.total)) *
                100;
            }
            else if (currentReport.name === "prospect") {
              currentReport.bg = this.cardColors[1].cardColor
              currentReport.textColor = this.cardColors[1].textColor
              const prospectTotal = getTotal("prospect");
              percent =
                (currentReport.total / (prospectTotal + currentReport.total)) *
                100;
            }
            // currentReport.bg = this.cardColors[i]?.cardColor || "#ffffff"; // Default to white if undefined
            // currentReport.textColor =
            //   this.cardColors[i]?.textColor || "#000000"; // Default to black if undefined
            currentReport.percent = percent.toFixed(0);
          }
        } else {
          console.error("Invalid response data", res);
        }
      },
      (error) => {
        console.error("Error fetching lead stage reports", error);
      }
    );
  }

  getSource() {
    this.apiService
      .getTagByTagCatgoryId(this.source_tagcat_id)
      .subscribe((res: any) => {
        this.sourceList = res.data;
      });
  }
  getTechnologyList() {
    this.apiService
      .getTagByTagCatgoryId(this.technology_catId)
      .subscribe((res: any) => {
        this.technology_List = res.data.slice(0, 4);
        let list = { _id: "All", displayname: "All" };
        this.technology_List.push(list);
        this.technology_List.sort((a, b) => {
          if (a.displayname < b.displayname) {
            return -1;
          }
          if (a.displayname > b.displayname) {
            return 1;
          }
          return 0;
        });
      });
  }
  getChannelReport(tech, techName, fromDate, toDate) {
    if (this.currentUrl == "outsource-leads-reports") {
      this.channelFromDate = fromDate;
      this.channelToDate = toDate
      this.apiService
        .getOutSourceLeadsReports(
          `fromDate=${this.channelFromDate}&toDate=${this.channelToDate}&channelGrouping=true&technology=${tech}&source=${this.selected_source}`
        )
        .subscribe(async (res: any) => {
          let result = res.items;
          let reports = [];
          let category = [];
          this.selectedTechnology = techName;
          this.selectedTechnologyId = tech;
          for (let i = 0; i < result.length; i++) {
            let obj = result[i];
            for (let key in obj) {
              if (key === "channelName") {
                category.push(obj[key]);
              } else {
                let reportObj = reports.find((x) => x.name === key);
                if (reportObj) {
                  reportObj.data.push(obj[key]);
                } else {
                  reports.push({ name: key, data: [obj[key]] });
                }
              }
            }
          }

          this.channelChartOptions = {
            chart: {
              height: 350,
              type: "bar",
            },
            colors: channelthemeColors,
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: "rounded",
                columnWidth: "55%",
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"],
            },
            series: reports,
            legend: {
              offsetY: 4,
            },
            xaxis: {
              categories: category,
            },
            yaxis: {
              title: {
                text: "(Leads)",
              },
            },
            fill: {
              opacity: 1,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return +val + "";
                },
              },
            },
          };
        });
    }
  }
  async getReports() {
    if (this.currentUrl == "outsource-leads-reports") {
      this.apiService
        .getOutSourceLeadsReports(
          `fromDate=${this.leadFromDate}&toDate=${this.leadToDate}`
        )
        .subscribe(async (res: any) => {
          let data = [];
          data = res.items;
          let reports = [];
          let categories = [];

          // iterate over each object in the result array
          data.forEach((obj) => {
            // add the created_by value to the categories array
            categories.push(obj.created_by);

            // iterate over each data object in the data array
            obj.data.forEach((dataObj) => {
              // find the report object with the same name as the lead_stage
              let report = reports.find((r) => r.name === dataObj.lead_stage);

              // if the report object doesn't exist, create a new one and push it to the reports array
              if (!report) {
                report = { name: dataObj.lead_stage, data: [] };
                reports.push(report);
              }

              // add the count value to the data array at the corresponding index
              const index = categories.length - 1;
              report.data[index] = dataObj.count;
            });
          });

          // fill missing data with null values
          reports.forEach((report) => {
            for (let i = 0; i < report.data.length; i++) {
              if (report.data[i] === null || report.data[i] === undefined)
                report.data[i] = 0;
            }
          });
          const sortedData = await reports.sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          this.columnChartOptions = {
            chart: {
              height: 350,
              type: "bar",
            },
            colors: themeColors,
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: "rounded",
                columnWidth: "55%",
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"],
            },
            series: sortedData,
            legend: {
              offsetY: 4,
            },
            xaxis: {
              categories: categories,
            },
            yaxis: {
              title: {
                text: "(Leads)",
              },
            },
            fill: {
              opacity: 1,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return +val + "";
                },
              },
            },
          };
        });
    }
    if (this.currentUrl == "training-leads-reports") {
      this.apiService
        .getTrainingLeadsReports(
          `fromDate=${this.leadFromDate}&toDate=${this.leadToDate}`
        )
        .subscribe(async (res: any) => {
          let data = [];
          data = res.items;
          let reports = [];
          let categories = [];

          // iterate over each object in the result array
          data.forEach((obj) => {
            // add the created_by value to the categories array
            categories.push(obj.created_by);

            // iterate over each data object in the data array
            obj.data.forEach((dataObj) => {
              // find the report object with the same name as the lead_stage
              let report = reports.find((r) => r.name === dataObj.lead_stage);

              // if the report object doesn't exist, create a new one and push it to the reports array
              if (!report) {
                report = { name: dataObj.lead_stage, data: [] };
                reports.push(report);
              }

              // add the count value to the data array at the corresponding index
              const index = categories.length - 1;
              report.data[index] = dataObj.count;
            });
          });

          // fill missing data with null values
          reports.forEach((report) => {
            for (let i = 0; i < report.data.length; i++) {
              if (report.data[i] === null || report.data[i] === undefined)
                report.data[i] = 0;
            }
          });
          const sortedData = await reports.sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          this.columnChartOptions = {
            chart: {
              height: 350,
              type: "bar",
            },
            colors: themeColors,
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: "rounded",
                columnWidth: "55%",
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"],
            },
            series: sortedData,
            legend: {
              offsetY: 4,
            },
            xaxis: {
              categories: categories,
            },
            yaxis: {
              title: {
                text: "(Leads)",
              },
            },
            fill: {
              opacity: 1,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return +val + "";
                },
              },
            },
          };
        });
    }
  }
  public chartClicked(e: any): void {
    //your code here
  }

  public chartHovered(e: any): void {
    //your code here
  }
  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  todayFilterReports() {
    this.leadFromDate = new Date().toISOString().split("T")[0];
    this.leadToDate = new Date().toISOString().split("T")[0];
    this.getReports()
  }
  dayFilterReports() {
    let date = new Date();
    date.setDate(date.getDate() - 2);
    this.leadFromDate = date.toISOString().split("T")[0];
    this.leadToDate = new Date().toISOString().split("T")[0];
    this.getReports()
    
  }
  weekFilterReports() {
    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.leadFromDate = date.toISOString().split("T")[0];
    this.leadToDate = new Date().toISOString().split("T")[0];
    this.getReports()
  }
  monthFilterReports() {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    this.leadFromDate = date.toISOString().split("T")[0];
    this.leadToDate = new Date().toISOString().split("T")[0];
    this.getReports()
  }
  todayFilterChannelReports() {
    this.channelFromDate = new Date().toISOString().split("T")[0];
    this.channelToDate = new Date().toISOString().split("T")[0];
    this.getChannelReport(this.selectedTechnology,this.selectedTechnologyId,this.channelFromDate,this.channelToDate)
  }
  dayFilterChannelReports() {
    let date = new Date();
    date.setDate(date.getDate() - 2);
    this.channelFromDate = date.toISOString().split("T")[0];
    this.channelToDate = new Date().toISOString().split("T")[0];
    this.getChannelReport(this.selectedTechnology,this.selectedTechnologyId,this.channelFromDate,this.channelToDate)
  }
  weekFilterChannelReports() {
    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.channelFromDate = date.toISOString().split("T")[0];
    this.channelToDate = new Date().toISOString().split("T")[0];
    this.getChannelReport(this.selectedTechnology,this.selectedTechnologyId,this.channelFromDate,this.channelToDate)
  }
  monthFilterChannelReports() {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    this.channelFromDate = date.toISOString().split("T")[0];
    this.channelToDate = new Date().toISOString().split("T")[0];
    this.getChannelReport(this.selectedTechnology,this.selectedTechnologyId,this.channelFromDate,this.channelToDate)
  }

  todayFilter() {
    let date = new Date();
    let fromDate
    let toDate
    fromDate = new Date().toISOString().split("T")[0];
    toDate = new Date().toISOString().split("T")[0];
    if (this.currentUrl == "training-leads-reports") {
      this.getleadStageReports("63e39db72052e0098e18e00e",fromDate,toDate)
    }
    if (this.currentUrl == "outsource-leads-reports") {
      this.getleadStageReports("63e39dd62052e0098e18e015",fromDate,toDate)
    }
  }
  dayFilter() {
    let date = new Date();
    let fromDate
    let toDate
    date.setDate(date.getDate() - 2);
    fromDate = date.toISOString().split("T")[0];
    toDate = new Date().toISOString().split("T")[0];
     if (this.currentUrl == "training-leads-reports") {
      this.getleadStageReports("63e39db72052e0098e18e00e",fromDate,toDate)
    }
    if (this.currentUrl == "outsource-leads-reports") {
      this.getleadStageReports("63e39dd62052e0098e18e015",fromDate,toDate)
    }
  }
  weekFilter() {
    let date = new Date();
    date.setDate(date.getDate() - 7);
    let fromDate
    let toDate
    fromDate = date.toISOString().split("T")[0];
    toDate = new Date().toISOString().split("T")[0];
     if (this.currentUrl == "training-leads-reports") {
      this.getleadStageReports("63e39db72052e0098e18e00e",fromDate,toDate)
    }
    if (this.currentUrl == "outsource-leads-reports") {
      this.getleadStageReports("63e39dd62052e0098e18e015",fromDate,toDate)
    }
  }
  monthFilter() {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    let fromDate
    let toDate
    fromDate = date.toISOString().split("T")[0];
    toDate = new Date().toISOString().split("T")[0];
    if (this.currentUrl == "training-leads-reports") {
      this.getleadStageReports("63e39db72052e0098e18e00e",fromDate,toDate)
    }
    if (this.currentUrl == "outsource-leads-reports") {
      this.getleadStageReports("63e39dd62052e0098e18e015",fromDate,toDate)
    }
  }
  getFilter(event){
    this.selected_filter=event.name
    if(this.selected_filter == 'Today'){
      this.todayFilter()
    }
    if(this.selected_filter == 'Last 3 Days'){
      this.dayFilter()
    }
    if(this.selected_filter == 'This Week'){
      this.weekFilter()
    }
    if(this.selected_filter == 'This Month'){
      this.monthFilter()
    }
    if(this.selected_filter == 'All'){
    if (this.currentUrl == "training-leads-reports") {
      this.getleadStageReports("63e39db72052e0098e18e00e",'','')
    }
    if (this.currentUrl == "outsource-leads-reports") {
      this.getleadStageReports("63e39dd62052e0098e18e015",'','')
    }
  }
  
  }
}

